import React from 'react'

// Partials
import Pricebox from 'views/shared/partials/pricebox'

// Functions
import getExchangeTypeName from 'functions/get-exchange-type-name';

const ConversionInfo = (props) => {
    return (
		<span className="price-conversion conversion-info">
			<span className={'label text-regular' + (props.dark ? ' dark' : 'light')}>
				{props.exchangeType && <React.Fragment>{getExchangeTypeName(props.exchangeType?.id || props.exchangeType)}</React.Fragment>} {props.currency} <i className="icon-arrow-right"></i> ₺
			</span>

			<Pricebox
				monochrome
				currency='₺'
				price={props.price} />
		</span>
    )
};

ConversionInfo.defaultProps = {
    exchangeType: '',
    currency: '',
	price: 0,
	dark: false,
}

export default ConversionInfo
